<template>
  <!-- 告警规则管理 -->
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>告警规则管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--<el-button type="primary" size="medium" icon="el-icon-caret-left" @click="gotoAlarmManage">返回告警记录列表</el-button>-->
    <!--<el-card style="margin-top: 10px;">-->
    <el-card>
      <el-table style="margin-top: 20px; font-size: 14px;" :data="alarmRuleList.result.alarmRuleList.slice((currentPage-1)*10, currentPage*10)">
        <el-table-column label="序号" type="index" width="50" ></el-table-column>
        <!--<el-table-column label="编号" prop="alarmRuleId" width="80"></el-table-column>-->
        <el-table-column label="规则名称" prop="alarmRuleName" width="80"></el-table-column>
        <el-table-column label="检测字段" prop="alarmAttribute" width="100"></el-table-column>
        <el-table-column label="运算符号" prop="symbol" width="100">
          <template slot="label">
            <span>哈哈</span>
          </template>
        </el-table-column>
        <el-table-column label="比较参数1" prop="parameter1" width="100"></el-table-column>
        <el-table-column label="比较参数2" prop="parameter2" width="100"></el-table-column>
        <el-table-column label="是否启用" prop="flag" width="100">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.flag ? 'success':'danger'"
            >{{scope.row.flag ? '已启用':'未启用'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="告警规则描述" prop="description" width="auto"></el-table-column>
        <el-table-column label="操作" width="230" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.flag" type="text" @click="setAlarmRule(scope.row)">停用规则</el-button>
            <el-button v-else type="text" @click="setAlarmRule(scope.row)">启用规则</el-button>
            <el-button type="text" icon="el-icon-delete" style="color: red;" @click="deleteAlarmRule(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" @click="addAlarmRuleDialogVisible = true" style="margin-top: 15px;">添加新规则</el-button>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="alarmRuleList.result.alarmRuleList.length"
          :current-page.sync="currentPage">
        </el-pagination>
      </div>
    </el-card>
    <AddAlarmRule :add-alarm-rule-dialog-visible="addAlarmRuleDialogVisible" @feedBack="addAlarmRuleFeedBack"></AddAlarmRule>
    <UpdateAlarmRule :update-alarm-rule-dialog-visible="updateAlarmRuleDialogVisible" @feedBack="updateAlarmRuleFeedBack"></UpdateAlarmRule>
  </div>
</template>

<script>
import AddAlarmRule from './AddAlarmRule'
import UpdateAlarmRule from './UpdateAlarmRule'

export default {
  name: 'AlarmRuleManage',
  components: { UpdateAlarmRule, AddAlarmRule },
  data(){
    return {
      currentPage:1,
      // 获取告警规则列表
      GetAlarmRuleList:{
        "version": 1,
        "method": "alarm.GetAlarmRuleList",
        "params": null,
        "token": "",
        "id": 0
      },
      // 告警规则列表
      alarmRuleList:{
        "version": 1,
        "result":{
          "alarmRuleList": [
            {
              "alarmRuleId": "",
              "alarmRuleName": "",
              "alarmAttribute": "",
              "symbol": "",
              "parameter1":"",
              "parameter2":"",
              "description":"",
              "flag":""
            },
          ]
        },
        "id": 0
      },
      // 启用/禁用规则
      SetAlarmRule:{
        "version": 1,
        "method": "alarm.SetAlarmRule",
        "params":{
          "alarmRuleId":"",
          "flag":""
        },
        "token": "",
        "id": 0
      },
      // 删除告警规则
      DeleteAlarmRule:{
        "version": 1,
        "method": "alarm.DeleteAlarmRule",
        "params":{
          "alarmRuleId":""
        },
        "token": "",
        "id": 0
      },
      addAlarmRuleDialogVisible: false,
      updateAlarmRuleDialogVisible: false,
    }
  },
  methods: {
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
    // 获取告警规则列表
    getAlarmRuleList(){
      this.GetAlarmRuleList.token = this.$store.state.token;
      console.log('获取告警规则列表');
      this.$axios.post(this.$mainUrl, this.GetAlarmRuleList).then(res=>{
        console.log('获取告警规则列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.alarmRuleList = res.data;
          this.alarmRuleList = JSON.parse(JSON.stringify(this.alarmRuleList).replace("range in", "区间"));
        }else{
          this.$message({
            type:'error',
            message: '获取告警规则失败，' + res.data.error.message
          })
        }
      })
    },
    // 删除告警规则
    deleteAlarmRule(row){
      this.DeleteAlarmRule.token = this.$store.state.token;
      this.DeleteAlarmRule.params.alarmRuleId = row._id;
      console.log('删除告警规则请求');
      console.log(this.DeleteAlarmRule);
      this.$confirm('此操作将永久删除告警规则“' + row.alarmRuleName + '”, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$mainUrl, this.DeleteAlarmRule).then(res=>{
          console.log('删除告警规则请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type:'success',
              message: '删除告警规则成功'
            })
            this.getAlarmRuleList()
          }else{
            this.$message({
              type:'error',
              message:'删除告警规则失败，' + res.data.error.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    // 启用/禁用规则
    setAlarmRule(row){
      let reqName;
      if(row.flag){
        reqName = '停用'
      }
      else{
        reqName = '启用'
      }
      this.SetAlarmRule.token = this.$store.state.token;
      this.SetAlarmRule.params.flag = !row.flag;
      this.SetAlarmRule.params.alarmRuleId = row._id;
      console.log('修改告警规则请求');
      console.log(this.SetAlarmRule);
      this.$confirm('此操作将' + reqName + '告警规则“' + row.alarmRuleName + '”, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$mainUrl, this.SetAlarmRule).then(res=>{
          console.log('修改告警规则请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type:'success',
              message: reqName + '告警规则成功'
            })
            this.getAlarmRuleList()
          }else{
            this.$message({
              type:'error',
              message:reqName + '告警规则失败，' + res.data.error.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    addAlarmRuleFeedBack(addAlarmRuleDialogVisible){
      this.addAlarmRuleDialogVisible = addAlarmRuleDialogVisible;
      this.getAlarmRuleList();
    },
    updateAlarmRuleFeedBack(updateAlarmRuleDialogVisible){
      this.updateAlarmRuleDialogVisible = updateAlarmRuleDialogVisible;
    },
    showUpdateAlarmRuleDialog(row){
      this.updateAlarmRuleDialogVisible = true;
    },
    deleteAlarmRuleDialog(row){
      this.$message({
        type:'success',
        message: '删除规则成功'
      })
    },
    gotoAlarmManage(){
      this.$router.push('/alarmManage');
    }
  },
  mounted() {
    this.getAlarmRuleList();
  }
}
</script>

<style scoped>

</style>
